import axios from "axios"

import { apiDomain } from "../../store/constants"

const BForm = {
    getMasterFormB (id) {
        return axios({
            url: apiDomain + `api/form-b/create?plan_id=` + id,
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    getMasterFormBMain (id) {
        return axios({
            url: apiDomain + `api/form-b/create?main_project_id=` + id,
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    storeFormB (data) {
        return axios({
            url: apiDomain + `api/form-b`,
            method: 'POST',
            data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    updateFormB (data) {
        return axios({
            url: apiDomain + `api/form-b/` + data.id,
            method: 'PUT',
            data: data.payload
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getFormBList (params) {
        return axios({
            url: apiDomain + `api/form-b`,
            method: 'GET',
            params
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getEditMasterFormB (id) {
        return axios({
            url: apiDomain + `api/form-b/` + id + '/edit',
            method: 'GET'
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },

    getEditMasterFormBInception (params) {
        return axios({
            url: apiDomain + `api/form-b/create/progress`,
            method: 'GET',
            params
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
    storeNewProgressFormB (data) {
        return axios({
            url: apiDomain + `api/form-b/new/progress`,
            method: 'POST',
            data
        }).catch((e) => {
            console.log('Catch error \n', e.message)
            return e.response
        })
    },
}

export default BForm